import { render, staticRenderFns } from "./budgetButton.vue?vue&type=template&id=4dc3544a&scoped=true"
import script from "./budgetButton.vue?vue&type=script&lang=js"
export * from "./budgetButton.vue?vue&type=script&lang=js"
import style0 from "./budgetButton.vue?vue&type=style&index=0&id=4dc3544a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3544a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc3544a')) {
      api.createRecord('4dc3544a', component.options)
    } else {
      api.reload('4dc3544a', component.options)
    }
    module.hot.accept("./budgetButton.vue?vue&type=template&id=4dc3544a&scoped=true", function () {
      api.rerender('4dc3544a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/activity_center/components/register_button/budgetButton.vue"
export default component.exports